import { useMemo } from 'react';
import { useClientCustomersQuery } from '@/api/auth/queries';
import { useEffectiveClientId } from '@/contexts/AdminClientsContext';
import {
  formatCustomerDisplayName,
  type CustomerDisplayInfo
} from '@/components/appointments/appointmentClientDisplay';

/**
 * Map of portal customer userId → display info for the effective tenant.
 * Used to resolve registered-user appointments that only store userId.
 */
export function useClientCustomerDisplayMap(enabled: boolean = true) {
  const effectiveClientId = useEffectiveClientId();
  const customersQuery = useClientCustomersQuery(
    effectiveClientId ?? '',
    enabled && !!effectiveClientId
  );

  const userDisplayById = useMemo(() => {
    const map = new Map<string, CustomerDisplayInfo>();
    for (const user of customersQuery.data?.users ?? []) {
      map.set(user.id, {
        label: formatCustomerDisplayName(user),
        name: user.name?.trim() || null,
        email: user.email,
        phone: user.phoneNumber
      });
    }
    return map;
  }, [customersQuery.data?.users]);

  return {
    userDisplayById,
    isLoading: customersQuery.isLoading,
    isFetching: customersQuery.isFetching
  };
}
